export class ComposerService {
    compositionUniqueSymbols(composition) {
        const composed = this.runCompose(composition);
        const symbols = composed.genePanel.genes
            .map((x) => x.symbol)
            .filter(this.filerTruthy);
        return [...new Set(symbols)];
    }
    runCompose(composition) {
        switch (composition.kind) {
            case "intersection":
                return this.runComposeIntersection(composition.genePanels);
            case "union":
                return this.runComposeUnion(composition.genePanels);
            case "singleton":
                return composition;
            default:
                throw new Error("Unexpected composition kind " + composition.kind);
        }
    }
    runComposeIntersection(genePanels) {
        let result = null;
        for (const panel of genePanels) {
            if (!result) {
                result = this.runCompose(panel);
            }
            else {
                result = this.composeIntersection(result, panel);
            }
        }
        if (result) {
            return result;
        }
        throw new Error("Unexpected null composition singleton");
    }
    runComposeUnion(genePanels) {
        let result = null;
        for (const panel of genePanels) {
            if (!result) {
                result = this.runCompose(panel);
            }
            else {
                result = this.composeUnion(result, panel);
            }
        }
        if (result) {
            return result;
        }
        throw new Error("Null composition is unexpected");
    }
    composeIntersection(left, right) {
        switch (left.kind) {
            case "singleton": {
                const rightComposed = this.runCompose(right);
                const name = `intersection(${left.genePanel.name},${rightComposed.genePanel.name})`;
                return {
                    kind: "singleton",
                    genePanel: {
                        name,
                        genes: this.genesIntersection(left.genePanel.genes, rightComposed.genePanel.genes),
                        references: this.referencesIntersection(left.genePanel.references || [], rightComposed.genePanel.references || []),
                    },
                };
            }
            case "empty":
                return {
                    kind: "singleton",
                    genePanel: {
                        name: "",
                        genes: [],
                        references: [],
                    },
                };
            default: {
                const leftComposed = this.runCompose(left);
                return this.composeIntersection(leftComposed, right);
            }
        }
    }
    composeUnion(left, right) {
        switch (left.kind) {
            case "singleton": {
                const rightComposed = this.runCompose(right);
                const name = `union(${left.genePanel.name},${rightComposed.genePanel.name})`;
                return {
                    kind: "singleton",
                    genePanel: {
                        name,
                        genes: this.genesUnion(left.genePanel.genes, rightComposed.genePanel.genes),
                        references: this.referencesUnion(left.genePanel.references || [], rightComposed.genePanel.references || []),
                    },
                };
            }
            case "empty":
                return this.runCompose(right);
            default: {
                const leftComposed = this.runCompose(left);
                return this.composeUnion(leftComposed, right);
            }
        }
    }
    genesIntersection(left, right) {
        const leftSymbols = left.map((x) => x.symbol);
        const rightSymbols = right.map((x) => x.symbol);
        const leftSet = new Set(leftSymbols);
        const rightSet = new Set(rightSymbols);
        const intersection = new Set([...leftSet].filter((x) => rightSet.has(x)));
        const result = [...intersection]
            .map((s) => {
            return leftSet.has(s)
                ? left.find((x) => x.symbol === s)
                : right.find((x) => x.symbol === s);
        })
            .filter(this.filerTruthy);
        return result;
    }
    genesUnion(left, right) {
        const leftSymbols = left.map((x) => x.symbol);
        const rightSymbols = right.map((x) => x.symbol);
        const leftSet = new Set(leftSymbols);
        const rightSet = new Set(rightSymbols);
        const union = new Set([...leftSet, ...rightSet]);
        const result = [...union]
            .map((s) => {
            return leftSet.has(s)
                ? left.find((x) => x.symbol === s)
                : right.find((x) => x.symbol === s);
        })
            .filter(this.filerTruthy);
        return result;
    }
    filerTruthy(t) {
        return !!t;
    }
    referencesIntersection(left, right) {
        const leftIds = left.map((x) => x.id);
        const rightIds = right.map((x) => x.id);
        const leftSet = new Set(leftIds);
        const rightSet = new Set(rightIds);
        const intersection = new Set([...leftSet].filter((x) => rightSet.has(x)));
        const result = [...intersection]
            .map((id) => {
            return leftSet.has(id)
                ? left.find((x) => x.id === id)
                : right.find((x) => x.id === id);
        })
            .filter(this.filerTruthy);
        return result;
    }
    referencesUnion(left, right) {
        const leftIds = left.map((x) => x.id);
        const rightIds = right.map((x) => x.id);
        const leftSet = new Set(leftIds);
        const rightSet = new Set(rightIds);
        const union = new Set([...leftSet, ...rightSet]);
        const result = [...union]
            .map((id) => {
            return leftSet.has(id)
                ? left.find((x) => x.id === id)
                : right.find((x) => x.id === id);
        })
            .filter(this.filerTruthy);
        return result;
    }
}
//# sourceMappingURL=ComposerService.js.map